import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onClick", "text"];

var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/FileInput/IconButton.js",
    _this = this;

import React from 'react';
import styled, { css } from 'styled-components';
import { withTheme } from '../../core/ThemeProvider';
import { responsiveStyles } from '../../core/utils/responsiveStyles';

var IconButton = function IconButton(_ref) {
  var onClick = _ref.onClick,
      text = _ref.text,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(ActionTextWrapper, _extends({}, rest, {
    onClick: onClick,
    enableInteraction: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 9,
      columnNumber: 5
    }
  }), text);
};

export var ActionTextWrapper = withTheme(styled.div.withConfig({
  displayName: "IconButton__ActionTextWrapper",
  componentId: "sc-ehrm6n-0"
})(["", ";"], function (_ref2) {
  var _coreTheme$iconButton, _coreTheme$iconButton2, _coreTheme$iconButton3, _coreTheme$iconButton4, _coreTheme$iconButton5, _coreTheme$iconButton6;

  var coreTheme = _ref2.coreTheme;
  return css(["color:", ";line-height:21px;font-family:", ";cursor:pointer;", ";", ";"], coreTheme.cl_sec_d1, (_coreTheme$iconButton = coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$iconButton2 = coreTheme.iconButton) === null || _coreTheme$iconButton2 === void 0 ? void 0 : _coreTheme$iconButton2.fontFamily) !== null && _coreTheme$iconButton !== void 0 ? _coreTheme$iconButton : coreTheme.ff_sec_bold, coreTheme !== null && coreTheme !== void 0 && (_coreTheme$iconButton3 = coreTheme.iconButton) !== null && _coreTheme$iconButton3 !== void 0 && _coreTheme$iconButton3.fontSize ? Object.assign({}, responsiveStyles({
    fontSize: coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$iconButton4 = coreTheme.iconButton) === null || _coreTheme$iconButton4 === void 0 ? void 0 : _coreTheme$iconButton4.fontSize
  }, coreTheme)) : {
    fontSize: coreTheme.fs_xl
  }, (coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$iconButton5 = coreTheme.iconButton) === null || _coreTheme$iconButton5 === void 0 ? void 0 : _coreTheme$iconButton5.fontWeight) && {
    fontWeight: coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$iconButton6 = coreTheme.iconButton) === null || _coreTheme$iconButton6 === void 0 ? void 0 : _coreTheme$iconButton6.fontWeight
  });
}));
export default withTheme(IconButton);